export enum ExternalRoutes {
  UtcTimeApi = 'http://worldtimeapi.org/api/timezone/UTC',
  TbkPrivacyPolicy = 'https://www.tbkbank.com/policies/privacy-policy/'
}
